$(document).ready(function() {
    $("#validate-btn").click(function(){
            // Validate input fields
            var isValid = true;
             $(".error-msg").hide();
            $(".input-field input").each(function(){
                if($(this).val() == ""){
                    isValid = false;
                    
                 $(this).siblings(".error-msg").show();
                } 
            });
            var email = $("#emails").val();
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(!emailRegex.test(email)){
                isValid = false;
                 $("#emails").siblings(".error-msg").text("Veuillez saisir une adresse e-mail valide.").show();

                
            } 
            // Validate phone number
            var phone = $("#telephone").val();
            var phoneRegex = /^\d{10}$/; // Change this regex according to your phone number format
            if(!phoneRegex.test(phone)){
                isValid = false;
                 $("#telephone").siblings(".error-msg").text("Veuillez saisir un numéro de téléphone valide à 10 chiffres.").show();
                
            } 
            if(isValid){
                // Perform further actions, such as form submission
                $(".valid-msg").hide();
                
                // alert("Form is valid!");
                $(".step1-content").hide();
                $(".step2-content").hide();
                $(".step3-content").show();
                $(".bullet.step3").addClass("active");
                var emailText = $(".email input").val();
                var fnameText =$(".fname input").val();
                var lnameText =$(".lname input").val();
                var sizeText = $(".production-information--sticky .variations .form__label__value").text();
                var colorText = $(".swatch-color-selector  .form__label__value").text();
                var priceAmt = $(".product-price-container ins .amount").text();

                var sizeMapping = {
                    "34": "1.5",
                    "34.5": "2",
                    "35": "2.5",
                    "35.5": "3",
                    "36": "3.5",
                    "37": "4",
                    "37.5": "4.5",
                    "38": "5",
                    "38.5": "5.5",
                    "39": "6",
                    "40": "6.5",
                    "40.5": "7",
                    "41": "7.5",
                    "42": "8",
                    "42.5": "8.5",
                    "43": "9",
                    "44": "9.5",
                    "44.5": "10",
                    "45": "10.5",
                    "46": "11"
                };
                
                var additionalValue = sizeMapping[sizeText];
                if (additionalValue) {
                  var finalValue = sizeText + " - " + additionalValue;
                }else{
                  var finalValue = sizeText;
                }
                
                $("#fullname").text(fnameText + " " + lnameText);
                $("#finalemail").text(emailText);
                $(".size-selected-text").text(finalValue);
                $(".color-selected-text").text(colorText);
                $("#p-size").val(finalValue);
                $("#product-price").val(priceAmt);
                $("#customer-fname").val(fnameText);
                $("#customer-lname").val(lnameText);
              
              
            } else {
                $(".valid-msg").show();
                
            }
        });
      $(document).click(function(event) {
        if (!$(event.target).closest('.reservation-button').length && !$(event.target).closest('.pop-up-reservation').length) {
          $('#reservation-pop-p-container').removeClass('show');
          $("body").removeClass("no-scroll");
          $('#reservation-pop-p-container').find('input').not('#product-image').val('');
          
          $('.right-content-information').show();
          $('.success-msg').hide();
          $('.step3-information-container *, .progress-bars *').removeClass("pointer-events");

        }
      });
      $('.reservation-button').click(function() {
        $('#reservation-pop-p-container').addClass('show');
          $(".step1-content").show();
          $(".step2-content").hide();
          $(".step3-content").hide();
          $(".bullet.step2").removeClass("active");
          $(".bullet.step3").removeClass("active");
          $("body").addClass("no-scroll");
      });
  
      $('.pop-up-reservation .close').click(function() {
        $("#reservation-pop-p-container").removeClass('show');
        $("body").removeClass("no-scroll");
      });
    
   $(document).on('click', '.re-magasin', function(e) {
        var locationText = $(this).closest('.pickup-availability-list__item').find('.pickup-availability-list__location').text();
        var locationId = $(this).closest('.pickup-availability-list__item').find('.pickup-availability-list__location').attr('id');
        var parts = locationText.split(" - ");
        var reference = parts[0];  // "7GLY1"
        var warename = parts[1];  // "Gabor Lyon"
        $('#finalstorename').text(locationText);
        $('#warehouse-name').val(warename);
        $('#warehouse-id').val(locationId);
    });


    $(document).on('click', '.bullet.step2.active, .bullet.step2.active + p', function(e) {
        e.preventDefault();
        $("#perinfos2").trigger("click");
    });
  

   $(document).on('click', '.re-magasin, #perinfos2, .back-to-step2', function(e) {
      $(".step1-content").hide();
      $(".step2-content").show();
      $(".step3-content").hide(); 
      $(".bullet.step2").addClass("active");
      $(".bullet.step3").removeClass("active");
    });
     $('.back-to-step1,.bullet.step1, .bullet.step1+ p,  #storeinfo2-step1 ').click(function() {
      $(".step1-content").show();
      $(".step2-content").hide();
      $(".step3-content").hide();
      $(".bullet.step2").removeClass("active");
       $(".bullet.step3").removeClass("active");
    });
});


